import { IActionBase, ICampaignPageState } from "../models/root.interface";
import { UPDATE_PAGINATION_TOTAL_CAMPAIGN, UPDATE_PAGINATION_POSTS_PER_PAGE_CAMPAIGN, UPDATE_PAGINATION_CURRENT_PAGE_CAMPAIGN, UPDATE_LOADING_STATE_CAMPAIGN, UPDATE_NOTFOUND_STATE_CAMPAIGN, UPDATE_TABLE_STATE_CAMPAIGN,UPDATE_SEARCH_CAMPAIGN, UPDATE_SEARCH_CURRENT_PAGE_CAMPAIGN, UPDATE_API_CALL_CAMPAIGN } from "../actions/campaignPage.action";


const initialState: ICampaignPageState = {
totalPostsCampaign: 0,  postsPerPageCampaign: 25, currentPageCampaign: 1, loadingCampaign: "block", notFoundCampaign: "none",tableCampaign:"none",searchCampaign:"",currentPageSearchCampaign:1, apiCallCampaign:false
};
function campaignPageReducer(state: ICampaignPageState = initialState, action: IActionBase): ICampaignPageState {
    switch (action.type) {
        case UPDATE_PAGINATION_TOTAL_CAMPAIGN:
            return { ...state, totalPostsCampaign: action.totalPostsCampaign };
        case UPDATE_PAGINATION_POSTS_PER_PAGE_CAMPAIGN:
            return { ...state, postsPerPageCampaign: action.postsPerPageCampaign };
        case UPDATE_PAGINATION_CURRENT_PAGE_CAMPAIGN:
            return { ...state, currentPageCampaign: action.currentPageCampaign };
        case UPDATE_LOADING_STATE_CAMPAIGN:
            return { ...state,loadingCampaign: action.loadingCampaign } ;
        case UPDATE_NOTFOUND_STATE_CAMPAIGN:
            return { ...state, notFoundCampaign: action.notFoundCampaign  };
        case UPDATE_TABLE_STATE_CAMPAIGN:
            return { ...state, tableCampaign: action.tableCampaign  };
        case UPDATE_SEARCH_CAMPAIGN:
            return { ...state, searchCampaign: action.searchCampaign }   
        case UPDATE_SEARCH_CURRENT_PAGE_CAMPAIGN:
            return { ...state, currentPageSearchCampaign: action.currentPageSearchCampaign }  
        case UPDATE_API_CALL_CAMPAIGN:
            return { ...state, apiCallCampaign: action.apiCallCampaign }  
        default:
            return state;
    }
}


export default campaignPageReducer;